export const colors = {
  //ALLARIA COLOR SYSTEM

  default: {
    "400": "#003366",
    "500": "#003366",
    "600": "#506E92",
    "700": "#a6a6a6",
    "800": "#797979",
    "900": "#4d4d4d",
    foreground: "#003366",
    DEFAULT: "#ffffff",
  },

  //PRIMARY SCALE
  primary: {
    50: "#e6f2fa",
    100: "#E8F1F8",
    200: "#9fceed",
    300: "#7bbce7",
    400: "#58aae0",
    500: "#3498da",
    600: "#2b7db4",
    700: "#22638e",
    800: "#194868",
    900: "#102e41",
    foreground: "#ffffff",
    DEFAULT: "#3498da",
  },

  //SECONDARY SCALE
  secondary: {
    50: "#fafafa",
    100: "#f4f4f4",
    200: "#ededed",
    300: "#e6e6e6",
    400: "#e0e0e0",
    500: "#d9d9d9",
    600: "#b3b3b3",
    700: "#8d8d8d",
    800: "#676767",
    900: "#414141",
    foreground: "#ffffff",
    DEFAULT: "#d9d9d9",
  },

  //SUCCESS SCALE
  success: {
    50: "#e2f5e5",
    100: "#b9e7c1",
    200: "#8fd99d",
    300: "#66cb78",
    400: "#3dbd54",
    500: "#14af30",
    600: "#119028",
    700: "#0d721f",
    800: "#0a5317",
    900: "#06350e",
    foreground: "#ffffff",
    DEFAULT: "#14af30",
  },

  //WARNING SCALE
  warning: {
    50: "#faf3e2",
    100: "#f2e3b8",
    200: "#ebd28f",
    300: "#e3c166",
    400: "#dcb13c",
    500: "#d4a013",
    600: "#af8410",
    700: "#8a680c",
    800: "#654c09",
    900: "#403006",
    foreground: "#ffffff",
    DEFAULT: "#d4a013",
  },

  //DANGER SCALE
  danger: {
    50: "#fbe8e8",
    100: "#f6c7c7",
    200: "#f0a7a7",
    300: "#eb8686",
    400: "#e56666",
    500: "#e04545",
    600: "#b93939",
    700: "#922d2d",
    800: "#6a2121",
    900: "#431515",
    // foreground: "#ffffff",
    DEFAULT: "#e04545",
  },

  //ACCENT SCALE
  accent: {
    300: "#34cbd9",
    400: "#34a8d9",
    500: "#3934d9",
    600: "#7cb4d9",
    700: "#425759",
  },

  foreground: {
    50: "#e6e9ed",
    100: "#c4cbd3",
    200: "#a1acb9",
    300: "#7f8d9f",
    400: "#5c6f85",
    500: "#3a506b",
    600: "#304258",
    700: "#263446",
    800: "#1c2633",
    900: "#111820",
    foreground: "#fff",
    DEFAULT: "#3a506b",
  },

  white: "#ffffff",
  black: "#000000",

  allariaMasPrimary: {
    light: {
      50: "#e6eef8",
      100: "#d9e5f4",
      200: "#b0c9e9",
    },
    normal: {
      300: "#0150b7",
      400: "#0148a5",
      500: "#014092",
    },

    //PRIMARY SCALE
    primary: {
      50: "#e6f2fa",
      100: "#E8F1F8",
      200: "#9fceed",
      300: "#7bbce7",
      400: "#58aae0",
      500: "#3498da",
      600: "#2b7db4",
      700: "#22638e",
      800: "#194868",
      900: "#102e41",
      foreground: "#ffffff",
      DEFAULT: "#3498da",
    },
    dark: {
      600: "#013c89",
      700: "#01306e",
      800: "#002452",
      900: "#001c40",
    },
  },

  allariaMasSecondary: {
    light: {
      50: "#ecedf0",
      100: "#d1d5db",
      200: "#acb3bf",
    },
    normal: {
      300: "#8690a1",
      400: "#626f84",
      500: "#3f4f69",
    },
    dark: {
      600: "#364359",
      700: "#2d384b",
      800: "#242d3c",
      900: "#1c242f",
    },
  },
};
